module.exports = __webpack_public_path__ + "static/media/37.51871abf.jpg";